<template>
  <div class="claim-detail">
    <table class="brief-table">
      <tbody>
        <tr>
          <td class="title">项目名称</td>
          <td colspan="3">
            <span>{{claimModel.projectName}}</span>
          </td>
        </tr>
        <tr>
          <td class="title">保函编号</td>
          <td>
            <span>{{claimModel.orderNumber}}</span>
            <Button type="primary" ghost size="small" shape="circle" style="margin-left: 16px" @click="$router.push({name: 'guarantee-detail', params: {orderNumber: claimModel.orderNumber}})">查看保函</Button>
          </td>
          <td class="title">保额</td>
          <td>
            <span>{{claimModel.guaranteeAmount/100/10000}}万元</span>
          </td>
        </tr>
        <tr>
          <td class="title">代偿方式</td>
          <td>
            {{claimModel.method}}
          </td>
          <td class="title">状态</td>
          <td>
            <Tag :color="getStatus(claimModel).color">{{getStatus(claimModel).text}}</Tag>
            <Button v-if="canAudit(claimModel)" type="warning" shape="circle" style="margin-left: 16px" @click="showAuditModal=true">审核</Button>
          </td>
        </tr>
        <tr>
          <td class="title">业主原因</td>
          <td>
            <span>{{claimModel.reasonByOwner}}</span>
          </td>
          <td class="title">承包商原因</td>
          <td>
            {{claimModel.reasonByContractor}}
          </td>
        </tr>
        <tr>
          <td class="title">索赔金额</td>
          <td>
            {{claimModel.amount/100/10000}}万元
          </td>
          <td class="title">使用保证金金额</td>
          <td>
            {{claimModel.depositUsed/100/10000}}万元
          </td>
        </tr>
        <tr>
          <td class="title">创建人</td>
          <td>
            {{claimModel.creatorName}}
          </td>
          <td class="title">创建时间</td>
          <td>
            {{getMoment(claimModel.createTime).format('YYYY-MM-DD HH:mm:ss')}}
          </td>
        </tr>
        <tr>
          <td class="title">审核人</td>
          <td>
            {{claimModel.auditorName}}
          </td>
          <td class="title">审核时间</td>
          <td>
            {{getMoment(claimModel.auditTime).format('YYYY-MM-DD HH:mm:ss')}}
          </td>
        </tr>
        <tr>
          <td class="title">审核意见</td>
          <td colspan="3">
            {{claimModel.comment}}
          </td>
        </tr>
      </tbody>
    </table>
    <Modal v-model="showPreview" title="查看图片" @on-cancel="showPreview=false;previewImgUrl=null">
      <img :src="previewImgUrl" v-if="showPreview&&typeof(previewImgUrl)==='string'" style="width: 100%">
      <img :src="previewImgUrl.url" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='image'" style="width: 100%">
      <a :href="previewImgUrl.url" target="_blank" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='file'">查看</a>
    </Modal>
    <Modal v-model="showAuditModal" title="审核代偿申请" @on-cancel="closeAuditModal" @on-ok="confirmAudit">
      <Form ref="auditForm" :model="auditModel"
        label-position="right"
        :label-width="120">
        <FormItem label="是否通过" prop="pass">
          <i-switch v-model="auditModel.pass">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
        </FormItem>
        <FormItem label="意见">
          <Input type="textarea" v-model="auditModel.comment" />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import Api from './../../api/Api.js'
import moment from 'moment'
export default {
  name: 'claim-detail',
  props: {
  },
  data () {
    return {
      loading: false,
      claimModel: {
        id: null,
        guaranteeId: null,
        reasonByOwner: null,
        reasonByContractor: null,
        method: null,
        amount: null,
        depositUsed: null,
        attachments: [],
        otherReason: null
      },
      subject: '承包商',
      guaranteeModel: {
        orderNumber: null
      },
      supvPerms: {
        canAudit: false,
        canPreAudit: false,
        canAuditTerminate: false,
        canAuditRenewal: false,
        canClaim: false
      },
      previewImgUrl: null,
      showPreview: false,
      showAuditModal: false,
      auditModel: {
        id: null,
        pass: true,
        comment: null
      }
    }
  },
  watch: {
    '$route.params.id': function (newVal) {
      if (newVal) {
        this.auditModel.id = newVal
        this.getClaimDetail()
      }
    },
  },
  mounted () {
    if (this.$route.params.id) {
      this.auditModel.id = this.$route.params.id
      this.getClaimDetail()
    } else {
      this.$Modal.error({
        title: '错误',
        content: '代偿编号为空',
        onOk: () => {
          this.$router.back()
        }
      })
    }
  },
  activated () {
  },
  deactivated () {
  },
  computed: {
    totalGuaAmount () {
      let mainAmount = this.guaranteeModel.amount || 0
      let jointAmount = 0
      if (this.guaranteeModel && this.guaranteeModel.jointGuarantors && this.guaranteeModel.jointGuarantors.length) {
        this.guaranteeModel.jointGuarantors.forEach((j) => {
          jointAmount += j.amount
        })
      }
      return mainAmount + jointAmount
    },
    totalGuaDepositAmount () {
      let mainAmount = this.guaranteeModel.counterCash || 0
      let jointAmount = 0
      if (this.guaranteeModel && this.guaranteeModel.jointGuarantors && this.guaranteeModel.jointGuarantors.length) {
        this.guaranteeModel.jointGuarantors.forEach((j) => {
          jointAmount += j.counterCash
        })
      }
      return mainAmount + jointAmount
    }
  },
  methods: {
    confirmAudit () {
      this.$Modal.confirm({
        title: '请确认',
        content: '<p>确认审核通过此笔代偿申请么？</p>',
        onOk: () => {
          this.doAudit()
        },
        onCancel: () => {
          this.closeAuditModal()
        }
      })
    },
    async doAudit () {
      let model = Object.assign({}, this.auditModel)
      if (!model.pass && !model.comment) {
        this.$Message.error('意见不能为空!')
        return false
      }
      this.loading = true
      this.$Spin.show()
      await Api.Guarantee.auditClaim(model)
        .then((payload) => {
          console.log('suc', payload)
          this.$Message.success('操作成功!')
          this.closeAuditModal()
          this.loading = false
          this.$Spin.hide()
          this.$router.back()
        })
        .catch(err => {
          console.log('err', err)
          this.$Message.error('提交失败!' + err.message)
          this.loading = false
          this.$Spin.hide()
        })
    },
    closeAuditModal () {
      this.showAuditModal = false
      this.auditModel = {
        id: this.$route.params.id,
        pass: true,
        comment: null
      }
    },
    getMoment (dt) {
      return moment(dt)
    },
    checkRolePermitted (roles) {
      if (this.$store.getters.userInfo.type === 127) {
        return true
      }
      let userRole = this.$common.userType[this.$store.getters.userInfo.type.toString()]
      if (roles instanceof Array) {
        return roles.indexOf(userRole) > -1
      }
      return roles == userRole
    },
    canEdit (item) {
      let status = item.status
      let needAudit = item.needAudit
      if (status === 0) {
        if (needAudit) {
          if (this.$store.getters.userInfo.type === 127) {
            return true
          } else if (this.$store.getters.userInfo.type === 7) {
            return this.getConfig('ENABLE_GEN_SUPV_CLAIM_GUA')
          } else if (this.$store.getters.userInfo.type === 5) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    },
    canAudit (item) {
      let status = item.status
      let needAudit = item.needAudit
      if (status === 0) {
        if (needAudit) {
          if (this.$store.getters.userInfo.type === 127) {
            return true
          } else if (this.$store.getters.userInfo.type === 7) {
            return false
          } else if (this.$store.getters.userInfo.type === 5) {
            return false
          } else {
            return true
          }
        } else {
          return false
        }
      } else {
        return false
      }
    },
    getStatus (item) {
      let status = item.status
      let needAudit = item.needAudit
      if (status === 1) {
        return {
          text: '已代偿',
          color: 'success'
        }
      } else if (status === 2) {
        return {
          text: '拒绝代偿',
          color: 'error'
        }
      } else if (status === 0) {
        if (needAudit) {
          return {
            text: '待审核',
            color: 'primary'
          }
        } else {
          return {
            text: '未代偿',
            color: 'default'
          }
        }
      }
    },
    getConfig (key) {
      return this.$store.getters.sysConfigs[key]
    },
    guaAmountValidator (rule, value, callback) {
      console.log(value * 100, this.totalGuaAmount)
      if (value * 100 <= this.totalGuaAmount) {
        callback()
      } else {
        callback(new Error('索赔额度不能超过保额'))
      }
    },
    guaDepositAmountValidator (rule, value, callback) {
      if (value * 100 <= this.totalGuaDepositAmount) {
        callback()
      } else {
        callback(new Error('保证金使用额度超过保函保证金总额'))
      }
    },
    getClaimDetail () {
      Api.Guarantee.getClaimDetail(this.$route.params.id).then(async (res) => {
        Object.assign(this.claimModel, res)
        this.claimModel.guaranteeId = res.id
      }).catch(err => {
        this.$Message.error('获取详情失败!' + err.message)
      })
    },
    getGuaranteeDetail (orderNumber) {
      Api.Guarantee.getGuaranteeDetail(orderNumber).then(async (res) => {
        this.guaranteeModel = {
          remarks: null
        }
        Object.assign(this.guaranteeModel, res)
        if (this.checkRolePermitted(['监管人','总监管人'])) {
          this.getSupervisionPermission()
        }
        if ([1, 2, 4].indexOf(this.guaranteeModel.status) < 0) {
          this.$Modal.error({
            title: '错误',
            content: '保函状态不允许发起代偿',
            onOk: () => {
              this.$router.back()
            }
          })
        }
        this.claimModel.guaranteeId = res.id
      }).catch(err => {
        this.$Message.error('获取保函详情失败!' + err.message)
      })
    },
    async getSupervisionPermission () {
      await this.$Api.Guarantee.getSupervisionPermission(this.$route.params.orderNumber)
      .then((res) => {
        console.log(res)
        Object.assign(this.supvPerms, res)
      })
      .catch(() => {
        this.supvPerms = {
          canAudit: false,
          canPreAudit: false,
          canAuditTerminate: false,
          canAuditRenewal: false,
          canClaim: false
        }
      })
    },
    async submit () {
      this.$refs.editForm.validate(async (valid) => {
        if (valid) {
          this.$Modal.confirm({
            title: '确认操作',
            content: '<p>确认修改代偿么？</p>',
            onOk: () => {
              this.doSubmit()
            }
          })
        }
      })
    },
    async doSubmit () {
      this.loading = true
      this.$Spin.show()
      let model = Object.assign({}, this.claimModel)
      model.amount = Math.round(model.amount * 100)
      model.depositUsed = Math.round(model.depositUsed * 100)
      if (model.reasonByOwner === '其他') {
        if (!model.otherReason) {
          this.$Message.error('其他原因不能为空!')
          return false
        } else {
          model.reasonByOwner += '-' + model.otherReason
        }
      }
      if (model.reasonByContractor === '其他') {
        if (!model.otherReason) {
          this.$Message.error('其他原因不能为空!')
          return false
        } else {
          model.reasonByContractor += '-' + model.otherReason
        }
      }
      let urls = []
      model.attachments.forEach((att) => {
        if (att.url instanceof Array) {
          urls = urls.concat(att.url.map((u) => {
            return u.name.replace('oss:', '')
          }))
        }
      })
      model.attachments = urls
      await Api.Guarantee.editClaim(model)
        .then((payload) => {
          console.log('suc', payload)
          this.$Message.success('操作成功!')
          this.claimModel= {
            guaranteeId: null,
            reasonByOwner: null,
            reasonByContractor: null,
            method: null,
            amount: null,
            depositUsed: null,
            attachments: [],
            otherReason: null
          }
          this.loading = false
          this.$Spin.hide()
          this.$router.back()
        })
        .catch(err => {
          console.log('err', err)
          this.$Message.error('提交失败!' + err.message)
          this.loading = false
          this.$Spin.hide()
        })
    },
    initAttachment () {
      let attaches = this.getConfig('GUARANTEE_CLAIM_ATTACHMENT_REQUIREMENTS')
      if (attaches && attaches instanceof Array && attaches.length) {
        this.claimModel.attachments = attaches.map(a => {
          a.filePath = null
          a.ossKeys = []
          a.url = []
          return a
        })
      }
    },
    getFormats (fmtStr) {
      let arr = fmtStr.split(',')
      let result = arr.map((a) => {
        return a.trim()
      })
      return result
    },
    previewUploaded (file) {
      let key = file.name.indexOf('oss:') === 0 ? file.name.substr(4) : file.name
      this.procOssKey(key).then((obj) => {
        console.log(obj)
        this.previewImgUrl = obj.url
        this.showPreview = true
      })
    },
    async procOssKey (k) {
      let url = await this.procOSSUrl(k)
      return new Promise((resolve) => {
        let surfix = url.substr(url.lastIndexOf('.') + 1).toLowerCase()
        if (surfix.indexOf('?')) {
          surfix = surfix.substring(0, surfix.indexOf('?'))
        }
        let type = 'image'
        switch (surfix) {
          case 'jpg':
            type = 'image'
            break
          case 'jpeg':
            type = 'image'
            break
          case 'png':
            type = 'image'
            break
          case 'gif':
            type = 'image'
            break
          case 'pdf':
            type = 'file'
            break
          case 'doc':
            type = 'file'
            break
          case 'docx':
            type = 'file'
            break
          case 'xls':
            type = 'file'
            break
          case 'xlsx':
            type = 'file'
            break
          case 'ppt':
            type = 'file'
            break
          case 'pptx':
            type = 'file'
            break
          default:
            type = 'file'
            break
        }
        resolve({
          name: k,
          url,
          type,
          surfix
        })
      })
    },
    procOSSUrl (_key) {
      return new Promise((resolve, reject) => {
        let url = ''
        let ossKey = window.encodeURIComponent(window.btoa(_key))
        Api.Guarantee.getOssUrl(ossKey).then((res) => {
          // console.log(typeof(res), res)
          url = res
          resolve(url)
        }).catch(err => {
          this.$Message.error('获取文件地址失败!' + err.message)
          reject(err)
        })
      })
    },
  }
}
</script>

<style lang="less">
</style>
